/**
 * @deprecated Use {@link isSubagentTool} instead.
 */
export const SUBAGENT_TOOL_NAME_SUFFIX = 'create_subagent';

const SUBAGENT_TOOLS = new Set([
  'mcp__subagent__create_subagent',
  'mcp__subagent__create_coding_agent',
]);

export const isSubagentTool = (tool: string): boolean =>
  SUBAGENT_TOOLS.has(tool);

const CHILD_CHAT_NAME_RE = /^(projects\/[^/]+\/)?chats\/[^/\s]+$/;

/**
 * The create_subagent tool returns the child chat's resource name as the
 * single text part of its tool_result content. Parse it back out.
 */
export const parseChildChatName = (
  content: string | null | undefined,
): string | null => {
  if (!content) return null;
  const trimmed = content.trim();
  return CHILD_CHAT_NAME_RE.test(trimmed) ? trimmed : null;
};
